module.exports = __webpack_public_path__ + "img/cosleep_guidance_img_subscribe2_cn@3x.51479425.png";